import { Component }      from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

// WS-6781. Shown while the columns are being matched. Skipping is always allowed:
// mapping by hand is fully available, and a proposal arriving afterwards is discarded.
@Component({
  selector   : 'wor-import-proposal-running',
  template: require('./import.proposal-running.component.html')
})
export class ImportProposalRunningComponent {
  constructor (
    public activeModal: NgbActiveModal
  ) {}
}
